
export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
    }
  },
  head: {
    htmlAttrs: {
      lang: 'en',
    },
    title: 'EchoWave - Register',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Sign Up for a EchoWave account to start video editing online.',
      },
    ],
  },
  middleware: ['not-authenticated'],
  methods: {
    async register() {
      if (this.password !== this.confirmPassword) {
        console.error('Passwords do not match')
        if (typeof $crisp !== 'undefined') {
          $crisp.push(['set', 'session:event', [[['register_error', { error: 'Passwords do not match', email: this.email }, 'orange']]]])
        }

        if (typeof posthog !== 'undefined') {
          posthog.capture('register_error')
        }
        return
      }

      try {
        await this.$fire.auth.createUserWithEmailAndPassword(this.email, this.password).then(() => {
          if (typeof $crisp !== 'undefined') {
            $crisp.push(['set', 'session:event', [[['register_complete', { email: this.email }, 'green']]]])
          }
          console.log('>> Signed in, redirect to dashboard app')
        })
      } catch (e) {
        if (typeof $crisp !== 'undefined') {
          $crisp.push(['set', 'session:event', [[['register_error', { error: e, email: this.email }, 'orange']]]])
        }
        if (typeof posthog !== 'undefined') {
          posthog.capture('register_error')
        }
        console.error('>> Register error', e)
      }
    },
  },
}
